import type { StepType } from "@reactour/tour";
import welcome from "./welcome";
import textBased from "./textBased";
import keyboardNav from "./keyboardNav";
import landmarks from "./landmarks";
import focusAndMotion from "./focusAndMotion";
import ariaLive from "./ariaLive";
import readerFeatures from "./readerFeatures";
import viewerAccessibility from "./viewerAccessibility";
import summary from "./summary";

export const a11yTourSteps = (_hostId: string) => {
	const steps: StepType[] = [
		...welcome,
		...textBased,
		...keyboardNav,
		...landmarks,
		...focusAndMotion,
		...ariaLive,
		...readerFeatures,
		...viewerAccessibility,
		...summary,
	];
	return steps;
};
